"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_security(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "38e3dab0-2abf-4a47-86d2-44d984411342",
    "data-name": "Security_ic_mid",
    viewBox: "0 0 192 192"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58,74V54c0-19.88,17-36,38-36h0c21,0,38,16.12,38,36V74",
    fill: "none",
    stroke: "#e60000",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "c0d2c69d-3a55-4fe2-9343-283b25faf407",
    "data-name": "<Gruppe>"
  }, /*#__PURE__*/React.createElement("line", {
    id: "61efd583-ca3e-4682-822c-d126132d1672",
    "data-name": "<Pfad>",
    x1: 96,
    y1: 114,
    x2: 96,
    y2: 142,
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "335c3c1f-7de9-46b8-8472-c2cd364c4dc0",
    "data-name": "Payment_ic"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 74,
    width: 124,
    height: 100,
    rx: 12,
    ry: 12,
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 108,
    r: 6,
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("title", null, "security-mid"), /*#__PURE__*/React.createElement("g", {
    id: "3b498c94-4383-4636-9e31-ffd1333226b2",
    "data-name": "ICON"
  }, /*#__PURE__*/React.createElement("use", {
    id: "45766081-9cdb-49ae-9d70-fa79792f5d57",
    "data-name": "Security_ic_mid",
    width: 192,
    height: 192,
    transform: "translate(0 0)",
    xlinkHref: "#38e3dab0-2abf-4a47-86d2-44d984411342"
  })));
}

var _default = ic_security;
exports.default = _default;